import cnpjValidator from "../cnpjValidator";
import cpfValidator from "../cpfValidator";

export default (data, questionModel) => {
  if (data.length === 18) {
    const cnpjIsValid = cnpjValidator(data);

    if (cnpjIsValid) {
      questionModel.description = "";
      return true;
    }

    questionModel.description = "Entre com um CNPJ válido!";
    return false;
  } else if (data.length === 14) {
    const cpfIsValid = cpfValidator(data);

    if (cpfIsValid) {
      questionModel.description = "";
      return true;
    }

    questionModel.description = "Entre com um CPF válido!";
    return false;
  } else if (data.length > 5 && data.length < 14) {
    questionModel.description = "Digíte no mínimo 11 números";
    return false;
  }

  return false;
};
